import React, { PureComponent } from "react";

import Template from "./Welcome.jsx";

export default class WelcomeController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      registerOverlayActive: true,
      endDialogActive: false,
    };
    this.handlers = {
      onEndDialogClick: this.onEndDialogClick.bind(this),
      onRegisterSuccess: this.onRegisterSuccess.bind(this),
      onCloseDialogClick: this.onCloseDialogClick.bind(this),
    };
  }

  onRegisterSuccess(customer) {
    const { onSuccess } = this.props;
    this.setState({
      registerOverlayActive: false,
      endDialogActive: true,
    });
    onSuccess && onSuccess(customer);
  }

  onEndDialogClick() {
    this.setState({
      endDialogActive: false,
    });
  }

  onCloseDialogClick() {
    this.setState({
      endDialogActive: false,
      registerOverlayActive: false,
    });
  }

  render() {
    return <Template {...this.props} {...this.state} {...this.handlers} />;
  }
}
